export {MagicProvider, useMagicContext} from './context';
export {
  prepareSingleShotMessages,
  useChatCompletionStream,
} from './query';
